import { Link } from "react-router-dom";
import { Facebook, Instagram, Youtube } from "lucide-react";
import Logo from '../../images/bookmybarber-logo.png'; // ✅ import image

export default function Footer() {
    return (
        <section className="footer">
            <div className="container mx-auto px-6 grid grid-cols-1 md:grid-cols-4 gap-8">

                {/* Brand */}
                <div>
                    <img className="logo" alt="logo" src={Logo} />
                    <p className="mt-3 text-gray-300 text-sm">
                        Your trusted barber booking platform.
                        Find barbers near you & book appointments instantly.
                    </p>
                </div>

                {/* Quick Links */}
                <div>
                    <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
                    <ul className="space-y-2 text-gray-300">
                        <li><Link to="/" className="hover:text-white">Home</Link></li>
                        <li><Link to="/barbers" className="hover:text-white">Barbers</Link></li>
                        <li><Link to="/booking" className="hover:text-white">Book Appointment</Link></li>
                        <li><Link to="/contact" className="hover:text-white">Contact Us</Link></li>
                    </ul>
                </div>

                {/* Support */}
                <div>
                    <h3 className="text-lg font-semibold mb-4">Legal</h3>
                    <ul className="space-y-2 text-gray-300">
                        <li><Link to="/privacy-policy" className="hover:text-white">Privacy Policy</Link></li>
                        <li><Link to="/terms-conditions" className="hover:text-white">Terms & Conditions</Link></li>
                        {/* <li><Link to="/faq" className="hover:text-white">FAQ</Link></li> */}
                    </ul>
                </div>

                <div>
                    <h3 className="text-lg font-semibold mb-4">Help</h3>
                    <ul className="space-y-2 text-gray-300">
                        <li><a href="tel:+918552857511" className="hover:text-white">+918552857511</a></li>
                        
                    </ul>
                </div>

                {/* Social Media */}
                <div>
                    <h3 className="text-lg font-semibold mb-4">Follow Us</h3>
                    <div className="social-icons">
                        <a href="#" className="p-2 bg-white/10 rounded-full hover:bg-white/20">
                            <Facebook size={20} />
                        </a>
                        <a href="#" className="p-2 bg-white/10 rounded-full hover:bg-white/20">
                            <Instagram size={20} />
                        </a>
                        <a href="#" className="p-2 bg-white/10 rounded-full hover:bg-white/20">
                            <Youtube size={20} />
                        </a>
                    </div>
                </div>

            </div>

            <div className="rights-section">
                © {new Date().getFullYear()} BookMyBarberNow. All rights reserved.
            </div>
        </section>
    );
}
